(function () {
    var _u = 'undefined';
    var _f = 'function';
    var _$destroy = '$destroy';

    //#region angular.js
    angular.module('agweb').controller('LayoutMasterController', ['$scope', '$timeout', '$http', '$anchorScroll',
        function LayoutMasterCtrl($scope, $timeout, $http, $anchorScroll) {
            var ctrl = this;

            var _q = tios.util.parseQuery(null, true);

            var _fadeTO = null;
            var _hideTO = null;

            var _listening = false;

            var _pp = enums.PP;
            var _ppv = enums.PPValues;

            let _followScroll = null;

            ctrl.ux = {
                //Nav vars
                showSub: null,
                subNav: null,
                showMNav: false,
                // Global page vars
                isPrestige: _q?.Prestige === 'true',
                // YourHomeApp page
                hideIntro: _q?.Intro === 'true',
                scrolled: false,
            };

            //-
            function menuItem(pp, query) {
                return { label: _ppv[pp].Description, url: urls[pp] + (!!query ? '?' + query : '') };
            }

            function _clickOffMNav(event) {
                if (event.target.hasAttribute('href')) {
                    $scope.$applyAsync(function () {
                        ctrl.ux.showMNav = false;
                        document.removeEventListener('click', _clickOffMNav);
                    });
                }
            }

            ctrl.showMNav = function () {
                ctrl.ux.showMNav = !ctrl.ux.showMNav;
                if (ctrl.ux.showMNav) {
                    document.addEventListener('click', _clickOffMNav);
                } else {
                    document.removeEventListener('click', _clickOffMNav);
                }
            };

            //#region Site menu
            ctrl.showSub = function (menu) {
                if (!!menu) {
                    if (menu !== 'Sub') ctrl.ux.subNav = menu;
                    ctrl.ux.showSub = ctrl.ux.subNav;
                    if (!!_fadeTO) $timeout.cancel(_fadeTO);
                } else {
                    ctrl.ux.showSub = null;
                    _fadeTO = $timeout(function () {
                        ctrl.ux.subNav = null;
                    }, 300);
                }
            };

            ctrl.toggleMSub = function (navObj) {
                if (ctrl.ux.showSub !== navObj.label) {
                    ctrl.ux.showSub = navObj.label;
                    ctrl.ux.subNav = navObj.sub;
                } else {
                    ctrl.ux.showSub = null;
                    _hideTO = $timeout(function () {
                        ctrl.ux.subNav = null;
                    }, 300);
                }
            };
            //#endregion Site menu

            //#region Scroll animation
            function scrollAnimation(e) {
                let scrollEnd = (window.scrollY + window.innerHeight);
                for (element of document.querySelectorAll('.animation-container')) {
                    let start = parseFloat(element.getAttribute('start'));
                    let end = parseFloat(element.getAttribute('end'));
                    let type = element.getAttribute('data-anim-type');
                    if (scrollEnd >= end && scrollEnd <= (end + window.innerHeight)) {
                        switch (type) {
                            case 'fade-between':
                                element.querySelector('.fade2').style.opacity =
                                    (scrollEnd - end) / (window.innerHeight - (end - start) - 50);
                                break;
                        }
                    }
                }
            }

            function headerFade(e) {
                $scope.$applyAsync(function () {
                    ctrl.ux.scrolled = document.scrollingElement.scrollTop >
                                       document.getElementById('site-header').getBoundingClientRect().height;
                });
            }

            function scrollFollow() {
                let parentTop = _followScroll.parentNode.getBoundingClientRect().top;
                
                $scope.$applyAsync(function () {
                    if (document.scrollingElement.scrollTop >= parentTop) {
                        _followScroll.classList.add('follow')
                    } else {
                        _followScroll.classList.remove('follow')
                    }
                    if (!!_followScroll.parentNode.offsetHeight &&
                        (document.scrollingElement.scrollTop >=
                        ((parentTop + _followScroll.parentNode.offsetHeight) - window.innerHeight))) {
                        _followScroll.classList.add('bottom');
                    } else {
                        _followScroll.classList.remove('bottom');
                    }
                });
                _listening = true;
            }
            //#endregion Scroll animation

            ctrl.init = function () {
                document.getElementById('site-container').classList.remove('loading');

                // Jump to the anchor tag if one is specified in the url
                // NB this is necessary for pages that navigate directly
                // from another to one with a # fragment, because the page
                // isn't rendered early enough by angular for the built-in 
                // browser navigation to work properly.

                $anchorScroll();

                $timeout(() => {
                    if (document.querySelector('.header-fade')) {
                        document.addEventListener('scroll', headerFade);
                    }

                //    if (document.querySelector('.animation-container')) {
                //        for (element of document.querySelectorAll('.animation-container')) {
                //            let bb = element.getBoundingClientRect();
                //            element.setAttribute('start', bb.top);
                //            element.setAttribute('end', bb.bottom);
                //        }

                //        window.addEventListener('scroll', scrollAnimation);
                //    }
                });
            };
            //-i
            ctrl.init();
        }
    ]);

})();